import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonApp, IonContent } from '@ionic/angular';

@Component({
  selector: 'app-scroll-top-btn',
  templateUrl: './scroll-top-btn.component.html',
  styleUrls: ['./scroll-top-btn.component.scss'],
})
export class ScrollTopBtnComponent  implements OnInit {

  @Input() content: IonContent | undefined;

  constructor() { }

  ngOnInit() {}

  scrollTop() {
    const header = document.getElementsByTagName('ion-header');
    header[0].scrollIntoView(
      { behavior: 'smooth', block: 'start', inline: 'nearest' }
    );
  }
}
